/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Duration_BadgeInputs */



/**
* | output |
* | --- |
* | "DURATION" |
*
* @param {Event_Ad_Duration_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_duration_badge = /** @type {((inputs?: Event_Ad_Duration_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Duration_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DUREE")
	if (locale === "de") return /** @type {LocalizedString} */ ("DAUER")
	if (locale === "it") return /** @type {LocalizedString} */ ("DURATA")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ПРОДОЛЖИТЕЛЬНОСТЬ")
	if (locale === "es") return /** @type {LocalizedString} */ ("DURACIÓN")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("期间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("間隔")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("DURAÇÃO")
	return /** @type {LocalizedString} */ ("DURATION")
});